export const getBadgeDimensions = (orientation, format) => {
  const isLandscape = orientation === 'landscape'

  const badgeWidth = isLandscape ? 4.0 : 3.0
  const badgeHeight = isLandscape ? 3.0 : 4.0

  const pageSize = Object.freeze({
    A4: 'a4',
    USLetter: 'letter'
  })

  return {
    isLandscape,
    startX: isLandscape ? (format === pageSize.A4 ? 0.05 : 0.25) : 0.85,
    startY: 1.0,
    spacingX: isLandscape ? 0 : 0.5,
    spacingY: isLandscape ? 0 : 0.5,
    badgeWidth,
    badgeHeight,
    badgePerRow: 2,
    badgePerColumn: isLandscape ? 3 : 2,
    qrWidth: isLandscape ? 0.68 : 0.9,
    qrHeight: isLandscape ? 0.68 : 0.9,
    logoWidth: badgeWidth - 0.2,
    logoHeight: isLandscape ? 1.2 : 1.0
  }
}

export const adjustFontSize = (text, fontSize) => {
  if (text.length < 25) {
    return { fontSize: fontSize + 1 }
  } else if (text.length < 30) {
    return { fontSize: fontSize + 0.5 }
  } else if (text.length > 30 && text.length <= 34) {
    return { fontSize: fontSize - 1 }
  } else if (text.length > 34) {
    return { fontSize: fontSize - 1.8 }
  }
  return { fontSize }
}

export const adjustFontSizeForLocation = (text, fontSize) => {
  if (text.length < 20) {
    return { fontSize: fontSize + 1 }
  } else if (text.length >= 20) {
    return { fontSize: fontSize + 0.5 }
  } else if (text.length >= 25) {
    return { fontSize: fontSize }
  } else if (text.length >= 30) {
    return { fontSize: fontSize - 0.5 }
  }
  return { fontSize }
}
